import { RootState } from '@/store';

export const selectNegociacaoCasos = (state: RootState) => state.negociacoes.list?.items || [];
export const selectNegociacaoCasosLoading = (state: RootState) =>
  state.negociacoes.list?.loading || false;
export const selectNegociacaoCasosError = (state: RootState) =>
  state.negociacoes.list?.error || null;
export const selectNegociacaoExportingCsv = (state: RootState) =>
  state.negociacoes.list?.isExportingCsv || false;

export const selectNegociacaoTabCounts = (state: RootState) =>
  state.negociacoes.list?.tabCounts || {
    all: 0,
    open: 0,
    concluded: 0,
    closed: 0,
    archived: 0,
    scheduled: 0,
    negotiationStarted: 0,
    active: 0,
    agreementClosed: 0,
    noAgreement: 0,
    paused: 0,
    failed: 0,
    withPendency: 0,
  };

const PERIODO_PREVIEW_VAZIO = { total: null, loading: false } as const;

export const selectNegociacaoPeriodoPreview = (state: RootState) =>
  state.negociacoes.list?.periodoPreview ?? PERIODO_PREVIEW_VAZIO;

export const selectNegociacaoCasosPagination = (state: RootState) => ({
  total: state.negociacoes.list?.total || 0,
  page: state.negociacoes.list?.page || 1,
  limit: state.negociacoes.list?.limit || 50,
  totalPages: state.negociacoes.list?.totalPages || 0,
});

export const selectBatchState = (state: RootState) => state.negociacoes.batch;
export const selectBatchCurrentStep = (state: RootState) =>
  state.negociacoes.batch?.currentStep || 'agent';
export const selectBatchSelectedAgent = (state: RootState) =>
  state.negociacoes.batch?.selectedAgentId || null;
export const selectBatchLoteId = (state: RootState) => state.negociacoes.batch?.loteId || null;
export const selectBatchName = (state: RootState) => state.negociacoes.batch?.batchName || '';
export const selectBatchUploadedFile = (state: RootState) =>
  state.negociacoes.batch?.uploadedFile || null;
export const selectBatchMapeamento = (state: RootState) =>
  state.negociacoes.batch?.mapeamento || null;
export const selectBatchRows = (state: RootState) => state.negociacoes.batch?.rows || [];
export const selectBatchTotals = (state: RootState) =>
  state.negociacoes.batch?.totals || {
    total: 0,
    valid: 0,
    invalid: 0,
    acordoFechado: 0,
    acordoEmAndamento: 0,
    bloqueioTemporario: 0,
    bloqueioPermanente: 0,
    duplicadoPlanilha: 0,
  };
export const selectBatchValidRows = (state: RootState) =>
  state.negociacoes.batch?.rows.filter((r) => r.status === 'valid') || [];
export const selectAcordosExistentesSummary = (state: RootState) => {
  const totals = state.negociacoes.batch?.totals;
  const temporarios = (totals?.bloqueioTemporario ?? 0) + (totals?.acordoEmAndamento ?? 0);
  const permanentes = (totals?.bloqueioPermanente ?? 0) + (totals?.acordoFechado ?? 0);
  const duplicidades = totals?.duplicadoPlanilha ?? 0;
  const total = temporarios + permanentes + duplicidades;
  return { temporarios, permanentes, duplicidades, total, count: total };
};
export const selectBatchScheduledDate = (state: RootState) =>
  state.negociacoes.batch?.scheduledDate;
export const selectBatchScheduledTime = (state: RootState) =>
  state.negociacoes.batch?.scheduledTime;
export const selectBatchIsProcessing = (state: RootState) =>
  state.negociacoes.batch?.isProcessing || false;

export const selectLotes = (state: RootState) => state.negociacoes.lotes?.items ?? [];
export const selectLotesDashboard = (state: RootState) =>
  state.negociacoes.lotes?.dashboard ?? {
    totalLotes: 0,
    casosAtivos: 0,
    taxaAcordoMedia: 0,
    valorEmNegociacao: 0,
    totalBloqueados: 0,
    pendencias: 0,
  };
export const selectLotesLoading = (state: RootState) => state.negociacoes.lotes?.loading ?? false;
export const selectLotesError = (state: RootState) => state.negociacoes.lotes?.error ?? null;
export const selectLotesPagination = (state: RootState) =>
  state.negociacoes.lotes?.pagination ?? { total: 0, page: 1, limit: 20, totalPages: 0 };

export const selectLoteDetail = (state: RootState) => state.negociacoes.loteDetail?.lote ?? null;
export const selectLoteDetailCasos = (state: RootState) =>
  state.negociacoes.loteDetail?.casos ?? [];
export const selectLoteDetailLoading = (state: RootState) =>
  state.negociacoes.loteDetail?.loading ?? false;
export const selectLoteDetailError = (state: RootState) =>
  state.negociacoes.loteDetail?.error ?? null;
export const selectLoteDetailErrorMessage = (state: RootState) =>
  state.negociacoes.loteDetail?.error?.message ?? null;
export const selectLoteDetailErrorStatus = (state: RootState) =>
  state.negociacoes.loteDetail?.error?.statusCode ?? null;
export const selectLoteDetailPagination = (state: RootState) =>
  state.negociacoes.loteDetail?.pagination ?? { total: 0, page: 1, limit: 10, totalPages: 0 };

export const selectNegociacoesListUi = (state: RootState) => state.negociacoes.listUi;

export const selectNegociacoesSituacoes = (state: RootState) =>
  state.negociacoes.situacoes?.items ?? [];
export const selectNegociacoesSituacoesLoading = (state: RootState) =>
  state.negociacoes.situacoes?.loading ?? false;
export const selectNegociacoesSituacoesLoaded = (state: RootState) =>
  state.negociacoes.situacoes?.loaded ?? false;

export const selectAjustesNegociacaoGrupos = (state: RootState) =>
  state.negociacoes.ajustes?.ajustesGrupos ?? [];
export const selectAjustesNegociacaoEscopo = (state: RootState) =>
  state.negociacoes.ajustes?.ajustesEscopo ?? null;
export const selectIsLoadingAjustesNegociacao = (state: RootState) =>
  state.negociacoes.ajustes?.isLoadingAjustes ?? false;
export const selectAjustesNegociacaoError = (state: RootState) =>
  state.negociacoes.ajustes?.ajustesError ?? null;
